import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  companyFetchStart,
  companyFetchSuccess,
  templateQuestionsFetchSuccess,
} from "./company.store";
import { doTemplateQuestionsFetchApiCall } from "../../../services/company/templateQuestion";
import { doCompanyFetchApiCall } from "../../../services/company/company";
import { Company } from "../../../model/company";
import { AssessmentTemplateQuestion } from "../../../model/assessment";
import { getActionErrorMessage, getCompanyId } from "../../../shared/utilities";
import { ApiBaseError } from "../../../model/error";

export const doCompanyFetch = createAsyncThunk<Company>(
  "company/company/fetchCompany",
  async (_, { dispatch, rejectWithValue }) => {
    dispatch(companyFetchStart());
    try {
      const companyId = getCompanyId();

      const response = await doCompanyFetchApiCall({
        id: companyId,
      });

      dispatch(companyFetchSuccess(response.data));
      return response.data;
    } catch (err) {
      const error = err as ApiBaseError;
      return rejectWithValue(
        getActionErrorMessage(error, "Error fetching company")
      );
    }
  }
);

export const doTemplateQuestionsFetch = createAsyncThunk<
  AssessmentTemplateQuestion[]
>(
  "company/company/fetchTemplateQuestions",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const companyId = getCompanyId();

      const response = await doTemplateQuestionsFetchApiCall({
        companyId,
      });
      if (response.data.length)
        dispatch(templateQuestionsFetchSuccess(response.data));
      return response.data;
    } catch (err) {
      const error = err as ApiBaseError;
      return rejectWithValue(
        getActionErrorMessage(error, "Error fetching company")
      );
    }
  }
);
